// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5551":"ccea8723","7558":"d44cf8c7"}[chunkId] + ".chunk.css";
};